import { Component } from "@angular/core";
import { NullableRegisteredUserDetails } from "@models/user.model";
import { UserService } from "../../services/user/user.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-profile-details",
    templateUrl: "./profile-details.component.html",
    styleUrl: "./profile-details.component.scss",
    standalone: false,
})
export class ProfileDetailComponent {
    public userDetails!: NullableRegisteredUserDetails;

    constructor(
        private userService: UserService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.getUserDetails();
    }

    private getUserDetails(): void {
        this.userService.getUserDetails().subscribe((response) => {
            this.userDetails = response;
        });
    }

    public goBack(): void {
        this.router.navigate(["/account"]);
    }
}
